module.exports = __webpack_public_path__ + "static/media/CheckingIn-Logo-Yellow-White.be08cdf3.png";